<script setup>
import { defineProps, defineEmits } from 'vue'

const props = defineProps({
  hasChanges: {
    type: Boolean,
    required: true
  },
  loading: {
    type: Boolean,
    required: true
  }
})

defineEmits(['save'])
</script>

<template>
  <v-btn
    color="primary"
    variant="tonal"
    prepend-icon="mdi-content-save"
    :disabled="!hasChanges || loading"
    @click="$emit('save')"
  >
    <slot>{{ $t ? $t('common.save') : 'Save' }}</slot>
  </v-btn>
</template>
